import { ZoomIn, ZoomOut } from "lucide-react";
import { Button } from "~/atoms/button";
import { type TimeDomain } from "../helpers";
import { useText } from "../text";
import {
  HORIZON_ZOOM_STEP,
  isSameDomain,
  zoomHorizon,
} from "./timelineHelpers";

interface Props {
  horizon: TimeDomain;
  // The whole year, or the whole history of the document the timeline follows
  fitLabel: string;
  fitHorizon: TimeDomain;
  onHorizonChange: (update: (horizon: TimeDomain) => TimeDomain) => void;
}

export const TimelineControls = ({
  horizon,
  fitLabel,
  fitHorizon,
  onHorizonChange,
}: Props) => {
  const text = useText();
  const zoomBy = (factor: number) => (current: TimeDomain) =>
    zoomHorizon(current, factor, 0.5);
  const zoomIn = zoomBy(1 / HORIZON_ZOOM_STEP);
  const zoomOut = zoomBy(HORIZON_ZOOM_STEP);

  return (
    <div className="flex items-center gap-1">
      <Button
        variant="outline"
        disabled={isSameDomain(horizon, fitHorizon)}
        onClick={() => onHorizonChange(() => fitHorizon)}
      >
        {fitLabel}
      </Button>
      <Button
        variant="outline"
        size="icon"
        aria-label={text.zoomOut}
        disabled={isSameDomain(horizon, zoomOut(horizon))}
        onClick={() => onHorizonChange(zoomOut)}
      >
        <ZoomOut />
      </Button>
      <Button
        variant="outline"
        size="icon"
        aria-label={text.zoomIn}
        disabled={isSameDomain(horizon, zoomIn(horizon))}
        onClick={() => onHorizonChange(zoomIn)}
      >
        <ZoomIn />
      </Button>
    </div>
  );
};
